import { getEnumValues } from './get-enum-values';
export enum DominantSide {
    Right = 'Right',
    Left = 'Left',
    Ambidextrous = 'Ambidextrous',
}
export const DominantSideValues = getEnumValues<DominantSide>(DominantSide);